<template>
  <div>
    <div class="title">{{ $t('PRESUPUESTO_confirmar_title') }}</div>

  <el-row class="prueba" v-if="presupuesto !== undefined">

      <!-- CABECERA -->
      <el-col class="container_col_1" :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
        <div class="contenedores">
          <el-card>
            <div class="card_body cabecera">
              <el-row>
                <el-col :span="24">
                  <div class="subtitulo">{{ $t('PRESUPUESTO_numero_presupuesto') }}</div>
                  <div class="sub-title">{{ presupuesto.Numero }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="subtitulo">{{ $t('PERFIL_empresa') }}</div>
                  <div class="sub-title">{{ presupuesto.Empresa }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="subtitulo">{{ $t('PERFIL_domicilio') }}</div>
                  <div class="sub-title">{{ presupuesto.Domicilio }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PRESUPUESTO_instancia')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{ descripcionInstancia }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('GENERAL_fecha')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{ presupuesto.FechaStr }}</div>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 10px">
                <el-col :span="10">
                  <div class="label">{{$t('PRESUPUESTO_vigencia')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{ presupuesto.FechaVigenciaStr }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PRESUPUESTO_nota_comercial')}}:</div>
                </el-col>
                <el-col :span="14">
                  <div class="greyLabel">{{ presupuesto.NotaComercial }}</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
      </el-col>

      <!-- TOTALES -->
      <el-col class="container_col_2" :xs="24" :sm="24" :md="17" :lg="17" :xl="17">
        <div class="contenedores">
          <el-card :body-style="{ padding: '0px' }">
            <el-row class="detalle_presupuesto">
              <el-col :span="2">
                <div :class="opened ? 'triangleDown' : 'triangleRight'" v-on:click="toggleOpen"></div>
              </el-col>
              <el-col :span="22" class="subtitulo">{{$t('PRESUPUESTO_detalles')}}</el-col>
            </el-row>

            <transition name="fade">
            <div v-show="opened">
              <el-row>
                <el-col :span="24">
                  <!-- Productos -->
                  <div class="card_list">
                    <div v-if="productos.length > 0">
                      <div
                        class="card_list_item"
                        v-for="(producto, index) in productos"
                        :key="index"
                      >
                        <ProductoSeleccionadoCard
                          :producto="producto"
                          :pantallaOrigen="'PresupuestoConfirmar'"
                        />
                      </div>
                    </div>
                    <div v-else class="loader">{{$t('PRODUCTO_agregar_producto')}}<i class="el-icon-circle-plus"/></div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </transition>

            <div class="totales">
              <el-row>
                <el-col :span="12">
                  <div class="blackLabel col1">{{$t('PRESUPUESTO_subtotal')}}</div>
                </el-col>
                <el-col :span="12">
                  <div class="blackLabel precio">${{ decimalToString(presupuesto.Subtotal) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PRESUPUESTO_bonificacion')}}</div>
                </el-col>
                <el-col :span="12">
                  <div class="label precio">${{ decimalToString(presupuesto.Bonificacion) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PRESUPUESTO_porcentaje_descuento')}}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label precio">{{ presupuesto.DescuentoPorcentaje }}%</div>
                </el-col>
                <el-col :span="8">
                  <div class="label precio">${{ decimalToString(presupuesto.DescuentoImporte) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PRESUPUESTO_intereses')}}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label precio">{{ presupuesto.InteresPorcentaje }}%</div>
                </el-col>
                <el-col :span="8">
                  <div class="label precio">${{ decimalToString(presupuesto.InteresImporte) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="blackLabel col1">{{$t('PRESUPUESTO_neto')}}</div>
                </el-col>
                <el-col :span="12">
                  <div class="blackLabel precio">${{ decimalToString(presupuesto.ImporteNeto) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PRESUPUESTO_iva')}}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label precio">{{ presupuesto.IVAPorcentaje }}%</div>
                </el-col>
                <el-col :span="8">
                  <div class="label precio">${{ decimalToString(presupuesto.IVAImporte)}}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PRESUPUESTO_iva_reducido')}}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label precio">{{ presupuesto.IVAReducidoPorcentaje }}%</div>
                </el-col>
                <el-col :span="8">
                  <div class="label precio">${{ decimalToString(presupuesto.IVAReducidoImporte) }}</div>
                </el-col>
              </el-row>
            </div>

            <el-row class="total">
              <el-col :span="10">
                <div class="label col1">{{$t('PRESUPUESTO_importe_final')}}</div>
              </el-col>
              <el-col :span="14 ">
                <div class="label precio">${{ decimalToString(presupuesto.ImporteTotal) }} *</div>
              </el-col>
            </el-row>
          </el-card>

          <el-row>
            <div class="label leyenda precio">*{{$t('PRESUPUESTO_sin_impuesto_ingresos_brutos')}}</div>
          </el-row>
          <div v-if="existeBaseDolar">
            <el-row >
              <el-col
                class="label leyenda precio"
              >{{$t('PRESUPUESTO_referencia_base_dolar')}}</el-col>
            </el-row>
        </div>
        </div>
      </el-col>
    </el-row>
    <div class="pageFooter">
    <div v-if="estadoProcesoConfirmacion === 0">
      <el-row class="hidden-xs-only">
        <el-col :span="24">
          <el-button style="margin-right: 40px" @click="onClose">{{ $t('GENERAL_cancelBtn') }}</el-button>
          <el-button type="primary" icon="el-icon-edit" @click="onEditarPresupuesto">{{ $t('PRESUPUESTO_editarPresupuestoBtn') }}</el-button>
          <el-button type="primary" icon="el-icon-check" @click="onConfirmarPresupuesto">{{ $t('PRESUPUESTO_confirmarPresupuestoBtn') }}</el-button>
        </el-col>
      </el-row>
      <el-row class="hidden-sm-and-up">
          <el-row>
            <el-col :span="12"><el-button style="margin-right: 40px" @click="onClose">{{ $t('GENERAL_cancelBtn') }}</el-button></el-col>
            <el-col :span="12"><el-button type="primary" icon="el-icon-edit" @click="onEditarPresupuesto">{{ $t('PRESUPUESTO_editarPresupuestoBtn') }}</el-button></el-col>
            <el-col :span="24" class="botonConfirmar"><el-button type="primary" icon="el-icon-check" @click="onConfirmarPresupuesto">{{ $t('PRESUPUESTO_confirmarPresupuestoBtn') }}</el-button></el-col>
          </el-row>
      </el-row>
    </div>
      <!-- <div v-if="estadoProcesoConfirmacion === 0">
        <el-button style="margin-right: 40px" @click="onClose">{{ $t('GENERAL_cancelBtn') }}</el-button>
        <el-button type="primary" icon="el-icon-edit" @click="onEditarPresupuesto">{{ $t('PRESUPUESTO_editarPresupuestoBtn') }}</el-button>
        <el-button type="primary" icon="el-icon-check" @click="onConfirmarPresupuesto">{{ $t('PRESUPUESTO_confirmarPresupuestoBtn') }}</el-button>
      </div> -->
      <div v-else-if="estadoProcesoConfirmacion === 1">
        <el-icon class="el-icon-loading"></el-icon>
        <div class="loadingMsg">{{ $t('PRESUPUESTO_confirmando_presupuesto') }}</div>
      </div>

      <!-- <div v-else-if="estadoProcesoConfirmacion === 2">
        <div class="presupuestoConfirmadoMsg">
          <el-icon class="el-icon-check"></el-icon>
          <span>{{ $t('PRESUPUESTO_confirmado') }}</span>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import ProductoSeleccionadoCard from "@/components/Cards/productoSeleccionadoCard";
  import { decimalToString } from '../Helpers/commonFunctions'
  import { showSuccess } from '../Mensaje'
  import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado'
  import { mapState } from "vuex";

  export default {
    name: "ConfirmarPresupuesto",
    components: {
      ProductoSeleccionadoCard,
    },
    data() {
      return {
        estadoProcesoConfirmacion: 0,
        productos: [],
        opened: false,
        presupuesto: undefined,
      };
    },

    computed:
    {
      ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario
        }),

        descripcionInstancia()
      {
        let descripcion = ''

        switch(this.presupuesto.Instancia)
        {
          case '0P':
            descripcion = this.$t('PRESUPUESTO_instancia_ingresado')
            break

          case 'ZP':
            descripcion = this.$t('PRESUPUESTO_instancia_historico')
            break

          default:
            descripcion = ''
        }
        return `(${this.presupuesto.Instancia}) ${descripcion}`
      },
      existeBaseDolar: function() {
        let flag = false;
        this.productos.forEach(producto => {
          if (producto.Moneda != "")
            flag = true;
        });

        return flag;
      }
    },

    methods:
    {
      decimalToString: decimalToString,

      onEditarPresupuesto()
      {
        // recupero el id del presupuesto
        let idPresupuesto = this.$route.params.id

        // llamo a la edición de presupuesto
        this.$router.push({ name: "Edicion Presupuesto", params: { id: idPresupuesto } })
      },

      toggleOpen() {
        this.opened = !this.opened
      },

      onConfirmarPresupuesto()
      {
        // indico que se está confirmando el presupuesto
        this.estadoProcesoConfirmacion = 1

        // recupero el id del presupuesto
        let idPresupuesto = this.$route.params.id

        // confirmo el presupuesto
        this.$store.dispatch('presupuestos/confirmarPresupuesto', { id: idPresupuesto })
        .then(data =>
        {
          if(data.CodigoResultado === 0)
          {
            // indico que se confirmó el presupuesto
            this.estadoProcesoConfirmacion = 2;
            showSuccess(this.$t('PRESUPUESTO_confirmado_success'));
            this.$store.dispatch("presupuestos/getPresupuesto", { id: idPresupuesto, idUsuario: this.idUsuario })
              .then(data =>
              {
                if(data.CodigoResultado === 0)
                {
                  var numero = JSON.parse(data.Datos).Numero;
                  // espero X milisegundos y continúo con la ejecución
                  setTimeout(() => this.$router.push({ name: "Presupuestos", params: { numeroPresupuesto: numero } }), 2000)
                }
                else
                {
                  mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado);
                }
              })
          }
          else
          {
            mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)

            // vuelvo al estado inicial de confirmación
            this.estadoProcesoConfirmacion = 0
          }
        })
      },

      onClose()
      {
        // llamo al catálogo de presupuestoS
        this.$router.push({ name: "Presupuestos", params: { keepFilter: true } })
      },

      agregarProductosSeleccionados(productos) {
        productos.forEach(element => {
          this.productos.push(element);
        });
      },

      cargarPresupuesto(presupuesto) {
        //debugger;
        this.presupuesto = presupuesto;

        let detalles = presupuesto.Detalles.map(x => {
          return {
            ...x,
            Bonificacion: x.BonificacionPorcentaje,
            Nombre: x.Producto.Clave,
            Clave: x.Producto.Clave,
            Descripcion: x.Producto.Descripcion,
          };
        });
        this.agregarProductosSeleccionados(detalles);
       //debugger;
        }

    },

    mounted()
    {
      // busco la cabecera del presupuesto a confirmar
      let idPresupuesto = this.$route.params.id
      /*this.$store.dispatch('presupuestos/getCabeceraPresupuesto', { id: idPresupuesto, idUsuario : this.idUsuario })
      .then((data) =>
      {
        if(data.CodigoResultado === 0)
        {
          this.presupuesto = JSON.parse(data.Datos)
        }
        else
        {
          mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)
        }
      })*/

      // busco el presupuesto
      this.$store
        .dispatch("presupuestos/getPresupuesto", { id: idPresupuesto, idUsuario: this.idUsuario })
        .then(data => {
          if (data.CodigoResultado === 0) {
            var presupuesto = JSON.parse(data.Datos);
            this.cargarPresupuesto(presupuesto);
            //debugger;
          } else {
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
          }
        })
        .finally(() => {
          this.loading = false;
          this.inicializandoPresupuesto = false;
        });
    },
    beforeMount () {
      //console.log(this.presupuesto);
    },
  }

</script>

<style scoped>

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 26px;
    padding: 0 0 7px;
  }

  .triangleRight,
  .triangleDown {
    width: 0;
    height: 0;
    border-style: solid;
    cursor: pointer;
  }
  .triangleRight {
    border-width: 8px 0 8px 13.9px;
    border-color: transparent transparent transparent var(--main-color);
  }
  .triangleDown {
    border-width: 13.9px 8px 0 8px;
    border-color: var(--main-color) transparent transparent transparent;
  }
  .detalle_presupuesto {
    padding: 15px;
  }

  .subtitulo {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    color: #999;
  }
  .cabecera .subtitulo {
    font-size: 16px;
  }
  .sub-title {
    padding: 3px 0px 10px 0px;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
  }

  .label {
    font-size: 14px;
    text-align: left;
    padding: 10px 0px;
  }
  .label.col1 {
    margin-left: 15px;
    justify-content: center;
  }
  .greyLabel {
    color: #6b6b6b;
    font-weight: normal;
    padding: 10px 0px;
    text-align: left;
  }
  .blackLabel {
    text-align: left;
    margin: 12px 0 4px 15px;
    justify-content: center;
    font-weight: bold;
  }

  .el-divider {
    margin: 2px 0 2px 0;
  }

  .totales {
    background: rgba(233, 233, 233, 0.959);
    padding: 0 20px 10px;
  }

  .contenedores {
    margin: 0px 20px 0 0;
  }

  .precio {
    text-align: right;
  }

  .total {
    background-color: var(--main-color);
    color: #ffffff;
    font-weight: bold;
    padding: 0 20px 10px;
  }

  .total .label {
    font-size: 1.5em;
  }

  .pageFooter {
    margin-top: 40px;
  }

  .pageFooter i {
    font-size: 40px;
    color: var(--main-color);
  }

  .pageFooter .loadingMsg {
    font-size: 12px;
    color: var(--main-color);
    margin-top: 5px;
  }



  .pageFooter .presupuestoConfirmadoMsg,
  .pageFooter .presupuestoConfirmadoMsg i {
    color: #4CAF50;
    font-size: 20px;
  }

  .pageFooter .presupuestoConfirmadoMsg i {
    margin-right: 10px;
  }
  @media (max-width: 600px) {
    .botonConfirmar{
      margin-top: 10px;
    }
  }

</style>